'use strict';
import System from 'utils/System';
import CommonBridge from 'common/CommonBridge';

const ImageAssets = {
  Common: {
    LoadingYp: System.getImage('loading_yp.png', 'common'), // 页面loading-yp
    LoadingMi: System.getImage('loading_mi.gif', 'common'), // 页面loading-yp
    AddEnableCountIcon: System.getImage('add_count_enable_icon.png', 'common'), // SKU 弹层可点击添加Icon
    AddDisableCountIcon: System.getImage('add_count_disable_icon.png', 'common'), // SKU 弹层不可点击添加Icon
    SubEnableCountIcon: System.getImage('sub_count_enable_icon.png', 'common'), // SKU 弹层可点击减少Icon
    SubDisableCountIcon: System.getImage('sub_count_disable_icon.png', 'common'), // SKU 弹层不可点击减少Icon
    RecHeaderLeft: System.getImage('rec_header_left.png', 'common'), // 推荐头部的图标
    RecHeaderRight: System.getImage('rec_header_right.png', 'common'), // 推荐头部的图标
    AddressClose: System.getImage('circle_close_grey.png', 'common'), // 四级地址弹窗关闭按钮
    Relocation: System.getImage('address_refresh.png', 'common'), // 重新定位图标
    LocationDownIcon: System.getImage('address_location_arrow_down_black.png', 'common'),
    AddressSearch: System.getImage('address_search.png', 'common'), // 搜索图标
    AddressLocationDown: System.getImage('address_location_down.png', 'common'), // 地址定位 椭圆背景下箭头
    IconArrowCircle: System.getImage('icon_arrow_circle_white.png', 'common'), // 圆形背景左箭头
    LocationIconBlack: System.getImage('location_icon_black.png', 'common'), // 定位图标-黑色
    LocationCenter: System.getImage('location_center.png', 'common'), // 定位地图-中间
    CloseCircleGreyNew: System.getImage('close_circle_grey_new.png', 'common'), // 带圆圈的关闭icon 产品站秋季改版新添加
    CloseCircleGrey: System.getImage('close_circle_grey.png', 'common'), // 带圆圈的关闭icon 融合改版添加
    CloseFullCircle: System.getImage('icon_close_full_circle.png', 'common'), // 有圆圈背景的关闭icon，米网SKU使用
    TongXunLu: System.getImage('icon_tong_xun_lu.png', 'common'), // 通讯录icon
    noPay: System.getImage('no_pay.png', 'common'), // 没有支付方式时收银台站位图
  },
  Icons: {
    BackToTop: System.getImage('icon_back_to_top.png', 'common'), // 返回顶部
    CloseWhite: System.getImage('icon_close_white.png', 'common'), // 关闭按钮-白色
    Search: System.getImage('icon_search.png', 'common'), // 搜索icon
    SearchGovSubsidy: System.getImage('icon_search_govSubsidy.png', 'common'), // 国补搜索icon
    LiveCardAnimation: System.getImage('icon_live_card_animation.gif', 'common'), // 直播动态图标
    AddBlackNew: System.getImage('icon_add_black_new.png', 'common'), // 添加icon-黑色
    ArrowLeftLightBlack: System.getImage('icon_arrow_left_lightgray.png', 'common'), // 箭头-左侧-浅灰色
    ArrowLeftCircleLightGray: System.getImage('icon_arrow_left_circle_lightgray.png', 'common'), // 箭头-左侧-圆形-灰色
    ArrowLeftBlack: System.getImage('icon_arrow_left_black.png', 'common'), // 箭头-左侧-黑色
    ArrowLeftBlack2: System.getImage('icon_arrow_left_black2.png', 'common'), // 箭头-左侧-黑色2
    ArrowLeftBlack3: System.getImage('icon_arrow_left_black3.png', 'common'), // 箭头-左侧-黑色3  凑单
    ArrowUpBlack: System.getImage('joinmore/icon_arrow_top_black.png'), // 箭头-向上-黑色  凑单
    ArrowUpRed: System.getImage('joinmore/icon_arrow_top_red.png'), // 箭头-向上-红色  凑单
    ArrowUpBlack3: System.getImage('icon_arrow_top_black3.png', 'common'), // 箭头-向上-黑色
    ArrowDownBlack: System.getImage('joinmore/icon_arrow_down_black.png'), // 箭头-向下-黑色  凑单
    ArrowDownRed: System.getImage('joinmore/icon_arrow_down_red.png'), // 箭头-向下-红色  凑单
    ArrowDownBlack2: System.getImage('icon_arrow_down_black2.png', 'common'), // 箭头-向下-黑色
    // ArrowUpBlack: System.getImage('icon_arrow_up_black.png', 'common'), // 箭头-向下-黑色 和凑单重复，暂时没有凑单之外使用的地方
    ArrowDownBlack3: System.getImage('icon_arrow_down_black3.png', 'common'), // 箭头-向下-黑色
    ArrowRightBlack2: System.getImage('icon_arrow_right_black2.png', 'common'), // 箭头-右侧-黑色
    ArrowRightBlack3: System.getImage('icon_arrow_right_black3.png', 'common'), // 箭头-右侧-黑色
    ArrowBottomBlack: System.getImage('joinmore/arrow_bottom_black.png'), // 箭头-下-黑色
    ArrowTopBlack: System.getImage('joinmore/arrow_top_black.png'), // 箭头-上-黑色
    ArrowDownDarkGray: System.getImage('cashier/icon_arrow_down_darkgray.png'), // 箭头-向下-浅灰色
    ArrowUpDarkGray: System.getImage('cashier/icon_arrow_up_darkgray.png'), // 箭头-向上-浅灰色
    ArrowLeftWhite2: System.getImage('icon_arrow_left_white2.png', 'common'), // 箭头-左侧-白色
    CheckBoxCheckDarkBrown: System.getImage('icon_checkbox_check_darkbrown.png', 'common'), // 选择框-选中态-深棕色
    CheckBoxCheckOrange: System.getImage('icon_checkbox_check_orange.png', 'common'),
    CheckBoxCheckedPay: System.getImage('cashier/icon_checkbox_check_pay.png'), // 选择框-收银台-选中
    CheckBoxUnCheckPay: System.getImage('cashier/icon_checkbox_uncheck_pay.png'), // 选择框-收银台-选中
    CheckBoxCheckWhite: System.getImage('icon_checkbox_check_white.png', 'common'),
    CloseGray: System.getImage('icon_close_gray.png', 'common'), // 关闭按钮-灰色
    CloseGray2: System.getImage('icon_close_gray2.png', 'common'), // 关闭按钮-灰色
    CloseCircleGray: System.getImage('icon_close_circle_gray.png', 'common'),
    MoreSolidGray2: System.getImage('icon_more_solidgray2.png', 'common'), // 更多-实心圆形-灰色
    MoreLightGray: System.getImage('icon_more_lightgray.png', 'common'), // 更多-圆形-浅灰色
    MoreSolidGray: System.getImage('icon_more_solidgray.png', 'common'), // 更多-实心圆形-灰色
    MoreBorderGray: System.getImage('icon_more_bordergray.png', 'common'), // 更多-圆形-灰色
    MinusBlackNew: System.getImage('icon_minus_black_new.png', 'common'), // 减icon-黑色
    CartBlack2: System.getImage('icon_cart_black2.png', 'common'), // 购物车黑色icon
    CartJionmoregoodsDarkGrey: System.getImage('joinmore/icon_cart_joinmoregoods_darkgrey.png'), // 购物车黑色icon
    CartJionmoregoodsLightGrey: System.getImage('joinmore/icon_cart_joinmoregoods_lightgrey.png'), // 购物车黑色icon
    Tip: System.getImage('cashier/icon_tip.png'),
    AdressTip: System.getImage('adress_tips.png', 'common'), // 提示，橙色
    TipBlack: System.getImage('icon_tip_black.png', 'common'), // 提示-黑色
    TipBlack2: System.getImage('icon_tip_black2.png', 'common'),
    TipLightGray: System.getImage('icon_tip_lightgray.png', 'common'), // 提示-浅灰色
    WhiteBlack: System.getImage('back_white.png', 'common'), // 提示-白色

    CloseBlack: System.getImage('icon_close_black.png', 'common'), // 关闭按钮-黑色
    ArrowRightDarkGray: System.getImage('icon_arrow_right_darkgray.png', 'common'), // 箭头-右侧-深灰色

    UpArrow: System.getImage('c_up_arrow.png', 'common'), // 发票页面上下拉小箭头
    DownArrow: System.getImage('c_down_arrow.png', 'common'), // 发票页面上下拉小箭头

    QuestionCirclelightGray: System.getImage('icon_question_circle_lightgray.png', 'common'), // 疑问-圆形-浅灰色==202008秋季改版新增icon
    QuestionLightGray: System.getImage('icon_question_lightgray.png', 'common'), // 问号-浅灰色
    MorePayIcon: System.getImage('more_pay.png', 'common'), // 更多支付方式
  },
  NoResult: {
    // CouponNoResult: System.getImage('no_coupon_mi_checkout.png', 'no_result'), // 米网优惠券无
    MiEcardImg: System.getImage('no_result_mi_ecard.png', 'no_result'), // 米网礼品卡 无卡
    QuestionLightGray: System.getImage('icon_question_lightgray.png', 'common'), // 问号-浅灰色
    SearchImg: System.getImage('no_result_search.png', 'common'), // 凑单搜索
    MiCartImage: System.getImage('no_result_mi_cart.png', 'common'), // 米网购物车无商品
    CartImg3: System.getImage('no_result_cart3.png', 'common'), // 购物车3
    CouponGrayImg: System.getImage('no_result_coupon_gray.png', 'common'), // 优惠券-灰色
    CouponYellowImg: System.getImage('no_result_coupon_yellow.png', 'common'), // 优惠券-黄色
    CouponInCart: System.getImage('no_result_coupon_cart.png', 'common'), // 购物车凑单弹层，无优惠券
  },
  Checkout: {
    AddressBottomBorder: System.getImage('address_bottom_border.png', 'common'), // 地址下边框
    AddressLocation: System.getImage('checkout/address_location.png', 'mishop'), // 添加地址定位icon
    AddressDefault: System.getImage('checkout/address_default.png'), // 地址默认图标
    JingxuanLogo: System.getImage('checkout/logo_ypjingxuan.png', 'youpin'), // 有品精选logo
    XiaomiLogo: System.getImage('checkout/logo_xiaomi_new.png', 'youpin'), // 小米logo
    ZhongchouLogo: System.getImage('checkout/logo_zhongchou.png', 'youpin'), // 众筹logo
    HaigouLogo: System.getImage('checkout/log_haigou.png', 'youpin'), // 海购logo
    RankIcon: System.getImage('checkout/rank_icon.png', 'youpin'),
    EvaluateIcon: System.getImage('checkout/evaluate_icon.png', 'youpin'),
    LocationTip: System.getImage('checkout/location_tips1.png'),
    RightRed: System.getImage('checkout/right_red1.png'),
    FMemberTopBG: System.getImage('checkout/f_member_banner_bg.png'),
    FlashBg: System.getImage('checkout/checkout_flash1.png'),
    StoreBg: System.getImage('checkout/checkout_store1.png'),
    FlashIcon: System.getImage('checkout/flash_icon_checkout.png'),
    StoreIcon: System.getImage('checkout/store_icon_checkout.png'),
    CheckoutAddressArrow: System.getImage('checkout/checkout_address_arrow.png'),
  },
  PayerInfo: {
    EditBlack: System.getImage('payerinfo/icon_edit_black.png', 'youpin'), // 编辑icon-黑色
    AgreeChecked: System.getImage('payerinfo/agree_checked.png', 'youpin'),
    AgreeUnchecked: System.getImage('payerinfo/agree_unchecked.png', 'youpin'),
  },
  Product: {
    ArrowLeftCircleGray: System.getImage('product/arrow_left_circle_gray2.png', 'mishop'),
    ArrowLeftBlack: System.getImage('product/arrow_left_black.png', 'mishop'),
    ShareCircleGray: System.getImage('product/share_circle_gray.png', 'mishop'),
    ShareBlack: System.getImage('product/share_black.png', 'mishop'),
    MoreCircleGray: System.getImage('product/more_circle_gray.png', 'mishop'),
    MoreBlack: System.getImage('product/more_black.png', 'mishop'),
    MoreIcon: System.getImage('product/more_icon.png', 'mishop'),
    Home: System.getImage('product/home.png', 'mishop'),
    Message: System.getImage('product/message.png', 'mishop'),
    Favor: System.getImage('product/favor.png', 'mishop'),
    DepreciateAlert: System.getImage('product/depreciate_alert.png', 'mishop'),
    DepreciateAlerted: System.getImage('product/depreciate_alerted.png', 'mishop'),
    RankTop: System.getImage('product/rank_top.png', 'mishop'),
    ArrowRight: System.getImage('product/arrow_right.png', 'mishop'),
    ArrowRightDiscount: System.getImage('product/product_arrow_right_discount.png', 'mishop'),
    SlideLeft: System.getImage('product/slide_left.png', 'mishop'),
    AnchorBg: System.getImage('product/anchor_bg.png', 'mishop'),
    AnchorIcon: System.getImage('product/anchor_icon.png', 'mishop'),
    ShadowLine: System.getImage('product/shadow_line.png', 'mishop'),
    ArrowRightCircle: System.getImage('product/arrow_right_circle.png', 'mishop'),
    SenceSelected: System.getImage('product/sence_selected.png', 'mishop'),
    SenceUnselect: System.getImage('product/sence_unselect.png', 'mishop'),
    SpecialPriceBg: System.getImage('product/special_price_bg.png', 'mishop'),
    Exclamation: System.getImage('product/exclamation.png', 'mishop'),
    EarnestBg: System.getImage('product/earnest_bg.png', 'mishop'),
    BuyIcon: System.getImage('product/buy_icon.png', 'mishop'),
    BuyingGuide: System.getImage('product/buying_guide.png', 'mishop'),
    DeviceCompare: System.getImage('product/device_compare.png', 'mishop'),
    NewProductTag: System.getImage('product/new_product_tag.png', 'mishop'),
    SenceArrow: System.getImage('product/sence_arrow.png', 'mishop'),
    ProductSwitch: System.getImage('product/product_switch.gif', 'mishop'),
    WB: System.getImage('product/wb.png', 'mishop'),
    LiveIcon: System.getImage('product/live_icon.png', 'mishop'),
    SenceLine: System.getImage('product/sence_line.png', 'mishop'),
    SenceInfo: System.getImage('product/sence_info.png', 'mishop'),
    SencePoint: System.getImage('product/sence_point.png', 'mishop'),
    DedRightBg: System.getImage('product/ded_right_bg.png', 'mishop'),
    TimeBg: System.getImage('product/time_bg.png', 'mishop'),

    ServiceIcon: System.getImage('product/service_icon.png', 'mishop'),
    VideoSelected: System.getImage('product/video_selected.png', 'mishop'),
    Video: System.getImage('product/video.png', 'mishop'),
    AddressArrow: System.getImage('product/address_arrow.png', 'mishop'),
    AddressLocationIcon: System.getImage('product/address_location_icon.png', 'mishop'),
    AddressUpdateNoticeIcon: System.getImage('product/address_update_notice_icon.png', 'mishop'),
    FinanceMoney: System.getImage('product/finance_money.png', 'mishop'),
    FinanceNumber: System.getImage('product/finance_number.png', 'mishop'),
    CollectIcon: System.getImage('product/collect_icon.png', 'mishop'),
    CollectedIcon: System.getImage('product/collected_icon.png', 'mishop'),
    CartIcon: System.getImage('product/cart_icon.png', 'mishop'),
    CustomerServiceIcon: System.getImage('product/customer_service_icon.png', 'mishop'),

    DiscountMore: System.getImage('product/discount_more.png', 'mishop'),
    FMemberDiscountMore: System.getImage('product/f_member_discount_more.png', 'mishop'),
    ModalClose: System.getImage('product/modal_close.png', 'mishop'),
    ModalArrowLeftBlack: System.getImage('product/modal_arrow_left_black.png', 'mishop'),
    Tips: System.getImage('product/tips.png', 'mishop'),
    CouponApply: System.getImage('product/coupon_apply.png', 'mishop'),
    CouponMiCoin: System.getImage('product/coupon_micoin.png', 'mishop'),
    MemberCouponApply: System.getImage('product/member_coupon_apply.png', 'mishop'),
    MemberCouponArrowdown: System.getImage('product/member_coupon_arrowdown.png', 'mishop'),
    MemberCouponArrowup: System.getImage('product/member_coupon_arrowup.png', 'mishop'),
    CouponMore: System.getImage('product/coupon_more.png', 'mishop'),
    CouponLess: System.getImage('product/coupon_less.png', 'mishop'),
    NewUserBG: System.getImage('product/new_user_bg2.png', 'mishop'),
    BarginLinearGradient: System.getImage('product/bargin_linear_gradient.png', 'mishop'),
    BatchSelectSkuTop: System.getImage('product/batch_select_sku_top.png', 'mishop'),
    BatchSelectSkuBottom: System.getImage('product/batch_select_sku_bottom.png', 'mishop'),
    DeliveryInfoIcon: System.getImage('product/delivery_info_icon.png', 'mishop'),
    InStoreAndSupportCompensation: System.getImage('product/instore_and_support_compensation.png', 'mishop'),
    SelectedAddressIcon: System.getImage('product/selected_address_icon.png', 'mishop'),
    QuestionIcon: System.getImage('product/question_icon.png', 'mishop'),
    VideoIcon: System.getImage('product/video_icon.png', 'mishop'),
    ModalCloseIcon: System.getImage('product/modal_close_icon.png', 'mishop'),
    AddDisableIcon: System.getImage('product/add_disable_icon.png', 'mishop'),
    AddIcon: System.getImage('product/add_icon.png', 'mishop'),
    ReduceDisableIcon: System.getImage('product/reduce_disable_icon.png', 'mishop'),
    ReduceIcon: System.getImage('product/reduce_icon.png', 'mishop'),
    ServiceIcon1: System.getImage('product/service1_icon.png', 'mishop'),
    ServiceIcon2: System.getImage('product/service2_icon.png', 'mishop'),
    ServiceIcon3: System.getImage('product/service3_icon.png', 'mishop'),
    ServiceIcon4: System.getImage('product/service4_icon.png', 'mishop'),
    ServiceIcon5: System.getImage('product/service5_icon.png', 'mishop'),
    ServiceNotice: System.getImage('product/service_notice.png', 'mishop'),
    ImageShowMoreIcon: System.getImage('product/image_show_more_icon.png', 'mishop'),
    WXIcon: System.getImage('product/wx_icon2.png', 'mishop'),
    PhoneIcon: System.getImage('product/phone_icon2.png', 'mishop'),
    WXIconDisable: System.getImage('product/wx_icon_disable.png', 'mishop'),
    PhoneIconDisable: System.getImage('product/phone_icon_disable.png', 'mishop'),
    WXTalk: System.getImage('product/wx_talk.png', 'mishop'),
    Star: System.getImage('product/star.png', 'mishop'),
    StarDisable: System.getImage('product/star_disable.png', 'mishop'),
    SplitStar: System.getImage('product/split_star.png', 'mishop'),
    RecommendMatchTips: System.getImage('product/recommend_match_tips.png', 'mishop'),
    TianJiang: System.getImage('product/tianjiang.png', 'mishop'),
    ShowMoreImageIcon: System.getImage('product/show_more_image_icon.png', 'mishop'),
    StoreLocationIcon: System.getImage('product/store_location_icon.png', 'mishop'),
    StoreAddressMore: System.getImage('product/store_address_more.png', 'mishop'),
    StoreAddressMore2: System.getImage('product/store_address_more2.png', 'mishop'),
    TradeIn: System.getImage('product/trade_in.png', 'mishop'),
    SendAndInstallArrow: System.getImage('product/send_and_install_arrow.png', 'mishop'),
    EmptyStore: System.getImage('product/empty_store.png', 'mishop'),
    GoHomeIcon: System.getImage('product/go_home_icon.png', 'mishop'),
    ServiceModalIcon: System.getImage('product/service_modal_icon1.png', 'mishop'),

    BrownCross: System.getImage('product/brown_cross.png', 'mishop'),
    GrayDotLine: System.getImage('product/gray_dot_line.png', 'mishop'),
    WhiteUmbrellaOnBlueShield: System.getImage('product/white_umbrella_on_blue_shield.png', 'mishop'),
    ArrowRightGray: System.getImage('product/arrow_right_gray.png', 'mishop'),
    WhitePlusSignOrangeRoundedSquare: System.getImage('product/white_plus_sign_orange_rounded_square.png', 'mishop'),
    WhiteCheckGrayRoundedSquare: System.getImage('product/white_check_gray_rounded_square.png', 'mishop'),
    WhiteCheckOrangeRoundedSquare: System.getImage('product/white_check_orange_rounded_square.png', 'mishop'),
    DarkGrayLens: System.getImage('product/dark_gray_lens.png', 'mishop'),
    LightGrayLens: System.getImage('product/light_gray_lens.png', 'mishop'),
    OrangeRightTriangle: System.getImage('product/orange_right_triangle.png', 'mishop'),
    RedFlame: System.getImage('product/red_flame.png', 'mishop'),
    OrangeFlame: System.getImage('product/orange_flame.png', 'mishop'),
    YellowFlame: System.getImage('product/yellow_flame.png', 'mishop'),
    GrayscaleRoundedSquare: System.getImage('product/grayscale_rounded_square.png', 'mishop'),
    FriendIcon: System.getImage('product/friend_icon.png', 'mishop'),
    GrayQuestionMark: System.getImage('product/gray_question_mark.png', 'mishop'),
    DarkGrayExclamationMark: System.getImage('product/dark_gray_exclamation_mark.png', 'mishop'),
    TianJiangClose: System.getImage('product/tianjiang_close.png', 'mishop'),
    DashedLineBrown: System.getImage('product/dashedLine_brown.png', 'mishop'),
    DashedLineBrownConsumables: System.getImage('product/dashed_line_consumables.png', 'mishop'),
    DashedLine: System.getImage('product/dashedLine.png', 'mishop'),
    CouponArrow: System.getImage('product/coupon_arrow.png', 'mishop'),
    MemberCouponArrow: System.getImage('product/member_coupon_arrow.png', 'mishop'),
    ConsumablesCouponArrow: System.getImage('product/consumables_coupon_arrow.png', 'mishop'),
    DiscountRulesMore: System.getImage('product/discount_rules_more.png', 'mishop'),
    ShowNumBg: System.getImage('product/show_num_bg.png', 'mishop'),
    ColorShadowLeft: System.getImage('product/color_shadow_left1.png', 'mishop'),
    ColorShadowRight: System.getImage('product/color_shadow_right1.png', 'mishop'),
    MiIconExchange: System.getImage('product/mi_icon_exchange.png', 'mishop'),
    fMemberArrowRight: System.getImage('product/f_member_arrow_right.png', 'mishop'),
    fMemberIcon: System.getImage('product/m_member_icon.png', 'mishop'),
    fMemberBeforeBG: System.getImage('product/f_member_before_bg.png', 'mishop'),
    fMemberAfterBG: System.getImage('product/f_member_after_bg.png', 'mishop'),
    fMemberModalTitle: System.getImage('product/f_member_modal_title.png', 'mishop'),
    fMemerIconBG: System.getImage('product/f_memer_icon_bg.png', 'mishop'),
    fMemberButton: System.getImage('product/f_member_button.png', 'mishop'),
    fMemberButtonReserve: System.getImage('product/f_member_button_reserve.png', 'mishop'),
    fMemberModalTopBG: System.getImage('product/f_member_modal_top_bg.png', 'mishop'),
    fMemberModalIcon: System.getImage('product/f_member_modal_icon.png', 'mishop'),
    fMemberModalClose: System.getImage('product/f_member_modal_close.png', 'mishop'),
    deliverySelect: System.getImage('product/delivery_select.png', 'mishop'),
    deliveryUnselect: System.getImage('product/delivery_unselect.png', 'mishop'),
    storeIcon: System.getImage('product/store_icon.png', 'mishop'),
    flashIcon: System.getImage('product/flash_icon.png', 'mishop'),
    shopIcon: System.getImage('product/shop_icon.png', 'mishop'),
    addressToLocationIcon: System.getImage('product/address_to_location_icon.png', 'mishop'),
    skuModalAddressIcon: System.getImage('product/sku_modal_address_icon.png', 'mishop'),
    skuShopIcon: System.getImage('product/sku_shop_icon.png', 'mishop'),
    skuStoreIcon: System.getImage('product/sku_store_icon.png', 'mishop'),
    skuFlashIcon: System.getImage('product/sku_flash_icon.png', 'mishop'),
    userAddressSelected: System.getImage('product/user_address_selected.png', 'mishop'),
    userAddressUnselect: System.getImage('product/user_address_unselect.png', 'mishop'),
    locationSelected: System.getImage('product/location_selected.png', 'mishop'),
    locationUnselect: System.getImage('product/location_unselect.png', 'mishop'),
    MiCoinInsufficient: System.getImage('product/mi_coin_insufficient.png', 'mishop'),
    CustomizeToSeeFull: System.getImage('product/customize_to_see_full.png', 'mishop'),
    CustomizeReset: System.getImage('product/customize_reset2.png', 'mishop'),
    CustomizeArrow: System.getImage('product/customize_arrow.png', 'mishop'),
    CouponDiamondCard: System.getImage('product/coupon-diamond-card.png', 'mishop'),
    DeliveryTagArrow: System.getImage('product/delivery_tag_arrow.png', 'mishop'),
    StageActUnactiveRight: System.getImage('product/stage_act_unactive_right.png', 'mishop'),
    StageActActiveRight: System.getImage('product/stage_act_active_right.png', 'mishop'),
    StageActActiveLeft: System.getImage('product/stage_act_active_left.png', 'mishop'),
    StageActUnactiveLeft: System.getImage('product/stage_act_unactive_left.png', 'mishop'),
    ActGov: System.getImage('product/act_gov.png', 'mishop'),
    ActYue: System.getImage('product/act_yue.png', 'mishop'),
    NormalChange: System.getImage('product/normal_change.png', 'mishop'),
    NormalFin: System.getImage('product/normal_fin.png', 'mishop'),
    NormalGov: System.getImage('product/normal_gov.png', 'mishop'),
    FinArrow: System.getImage('product/fin_arrow.png', 'mishop'),
    GovArrow: System.getImage('product/gov_arrow.png', 'mishop'),
    ChangeArrow: System.getImage('product/change_arrow.png', 'mishop'),
    AddNewDeviceIcon: System.getImage('product/add_new_device_icon.png', 'mishop'),
    ChannelSelectNewNextIcon: System.getImage('product/channel_select_new_next.png', 'mishop'),
    ChannelNewDeviceNextIcon: System.getImage('product/channel_new_device_next.png', 'mishop'),
  },
  Cashier: {
    BGMiCoin: System.getImage('cashier/bg_micoin.png'),
    FCoinBG: System.getImage('cashier/f_coin_bg.png'),
    MiCoinIcon: System.getImage('cashier/micoin_icon.png'),
    NormalMiCoinBg: System.getImage('cashier/normal_micoin_bg.png'),
    NCoinBG: System.getImage('cashier/n_coin_bg.png'),
    FCoinBtn: System.getImage('cashier/f_coin_btn.png'),
    CoinBtn: System.getImage('cashier/coin_btn.png'),
  },
  StoreAddress: {
    BackIcon: System.getImage('storeAddress/back_icon.png', ''),
    LocalIcon: System.getImage('storeAddress/local_icon.png', ''),
    LocalArrow: System.getImage('storeAddress/local_arrow.png', ''),
    SlectIcon: System.getImage('storeAddress/select_icon.png', ''),
    Relocation: System.getImage('storeAddress/relocation.png', ''),
    MoreArrow: System.getImage('storeAddress/more_arrow.png', ''),
    SearchAddress: System.getImage('storeAddress/search_address.png', ''),
  },
  Store: {
    MiIcon: System.getImage('store/mi_icon.png', 'mishop'),
  },
  Pano: {
    ArrowRight: System.getImage('pano/store_arrow_right.png', 'mishop'),
    Location: System.getImage('pano/location.png', 'mishop'),
    Explore: System.getImage('pano/explore.png', 'mishop'),
    Close: System.getImage('pano/close.png', 'mishop'),
    StoreImage: System.getImage('pano/store.png', 'mishop'),
  },
};

// if (CommonBridge.isMJYPApp()) {
ImageAssets.youpin = {
  Common: {
    VipBg: System.getImage('common/vip_bg.png', 'youpin'),
    EditGray: System.getImage('common/icon_edit_gray.png', 'youpin'), // 编辑icon-灰色
  },
  Cart: {
    MessageIcon: System.getImage('cart/cart_message_icon.png', 'youpin'),
    VipMemberBackground: System.getImage('cart/cart_vip_member_background.png', 'youpin'),
    Select: System.getImage('cart/cart_checkbox_select_icon.png', 'youpin'),
    Unselect: System.getImage('cart/cart_checkbox_unselect_icon.png', 'youpin'),
    Disable: System.getImage('cart/cart_checkbox_disable_icon.png', 'youpin'),
    VipPostageIcon: System.getImage('cart/cart_vip_postage.png', 'youpin'),
    ArrowUp: System.getImage('cart/cart_fee_arrow_up_icon.png', 'youpin'),
    ArrowUpGray: System.getImage('cart/cart_fee_arrow_up_gray_icon.png', 'youpin'),
    ArrowDown: System.getImage('cart/cart_fee_arrow_down_icon.png', 'youpin'),
    ArrowDownGray: System.getImage('cart/cart_fee_arrow_down_gray_icon.png', 'youpin'),
    Close: System.getImage('cart/cart_fee_close_icon.png', 'youpin'),
    Close1: System.getImage('cart/cart_close_icon.png', 'youpin'),
    UsedTag: System.getImage('cart/coupon_tag_used.png', 'youpin'),
    GetedTag: System.getImage('cart/coupon_tag_geted.png', 'youpin'),
    BlackPlus: System.getImage('cart/plus_black_icon.png', 'youpin'),
    ScrollShadow: System.getImage('cart/scroll_shadow.png', 'youpin'),
    SelectedProductBg: System.getImage('cart/selected_product_bg.png', 'youpin'),
  },
  Coupon: {
    UpCouponShadow: System.getImage('coupon/up_coupon_shadow.jpg', 'youpin'), // UP会员优惠券底纹图
    UpCouponInvalidShadow: System.getImage('coupon/up_coupon_invalid_shadow.jpg', 'youpin'), // UP会员优惠券底纹图
    CouponHeaderRight: System.getImage('coupon/coupon_header_right.png', 'youpin'), // 专享优惠券header的右侧icon
    CouponHeaderLeft: System.getImage('coupon/coupon_header_left.png', 'youpin'), // 专享优惠券header的左侧icon
    CouponHightBg: System.getImage('coupon/coupon_high_bg.png', 'youpin'),
    InvalidCouponGrayBg: System.getImage('coupon/coupon_invalid_gray_bg.png', 'youpin'),

    InvalidVipMember: System.getImage('coupon/coupon_invalid_vip_member.png', 'youpin'), // Vip会员失效Icon
    InvalidVipMemberBackgroundLeft: System.getImage('coupon/coupon_invalid_vip_member_background_left.png', 'youpin'), // Vip会员失效背景
    InvalidVipMemberBackgroundRight: System.getImage('coupon/coupon_invalid_vip_member_background_right.png', 'youpin'), // Vip会员失效背景
    UpCoupon: System.getImage('coupon/up_coupon.png', 'youpin'), // 弹窗- UP会员左上角
    BestCoupon: System.getImage('coupon/best_coupon.png', 'youpin'), // 弹窗- 最优可享

    NearExpirationRight: System.getImage('coupon/coupon_near_expriation_bg.png', 'youpin'), // 优惠券快过期角标
  },
  Address: {},
  ProdDetail: {
    SkuSeckillIcon: System.getImage('product/sku_seckill_icon.png', 'youpin'),
  },
  Checkout: {
    AddressDefault: System.getImage('checkout/address_default.png', 'youpin'), // 地址默认图标
    CheckoutBoxUnselect: System.getImage('checkout/icon_checkbox_circle_uncheck_palebrown.png'), // 选择框-未选中态-棕黄色==202008秋季改版新增icon
    CheckBoxCheckSelected: System.getImage('checkout/icon_checkbox_check_pale_brown.png'), // 选择框-选中态-棕黄色==202008秋季改版新增icon
    DashedLineBrown: System.getImage('checkout/dashed_line_brown.png', 'youpin'),
    DashedLineGray: System.getImage('checkout/dashed_line_gray.png', 'youpin'),
    CouponArrowUp: System.getImage('checkout/icon_arrow_up_darkyellow.png', 'youpin'), // 箭头-向上-浅黄色
    CouponArrowDown: System.getImage('checkout/icon_arrow_down_darkyellow.png', 'youpin'), // 箭头-向下-浅黄色
  },
  paySuccess: {
    vipIcon: System.getImage('paySuccess/vip-icon.png', 'youpin'),
  },
};
// }

// if (CommonBridge.isMishopApp()) {
// 临时引有品的图占位
ImageAssets.mishop = {
  Common: {
    Unselect: System.getImage('common/unselect.png', 'mishop'),
    Selected: System.getImage('common/selected.png', 'mishop'),
    FriendMember: System.getImage('common/icon_friend_menber_tag.png', 'mishop'),
  },
  Cart: {
    BulletinClose: System.getImage('cart/mishop_cart_bulletin_close.png', 'mishop'),
    TipGray: System.getImage('cart/cart_tip_gray.png', 'mishop'),
    CartArrowRight: System.getImage('cart/cart_arrow_right.png', 'mishop'),
    MessageIcon: System.getImage('cart/cart_message_icon.png', 'youpin'),
    Select: System.getImage('cart/cart_checkbox_select_icon.png', 'mishop'),
    Unselect: System.getImage('cart/cart_checkbox_unselect_icon.png', 'mishop'),
    DisableSelect: System.getImage('cart/disabled_selecte.png', 'mishop'), // 赠品不可选
    Disable: System.getImage('cart/cart_checkbox_disable_icon.png', 'youpin'),
    VipPostageIcon: System.getImage('cart/cart_vip_postage.png', 'youpin'),
    ArrowDownRed: System.getImage('cart/cart_fee_arrow_down_red.png', 'mishop'),
    ArrowUp: System.getImage('cart/cart_arrow_up.png', 'mishop'),
    ArrowUpGray: System.getImage('cart/cart_fee_arrow_up_gray_icon.png', 'youpin'),
    ArrowDown: System.getImage('cart/cart_arrow_down.png', 'mishop'),
    ArrowDownGray: System.getImage('cart/cart_fee_arrow_down_gray_icon.png', 'youpin'),
    ArrowRight2: System.getImage('cart/cart_arrow_right2.png', 'mishop'),
    Close: System.getImage('cart/cart_fee_close_icon.png', 'mishop'),
    Close1: System.getImage('cart/cart_close_icon.png', 'youpin'),
    UsedTag: System.getImage('cart/coupon_tag_used.png', 'youpin'),
    GetedTag: System.getImage('cart/coupon_tag_geted.png', 'youpin'),
    BlackPlus: System.getImage('cart/plus_black_icon.png', 'youpin'),
    ScrollShadow: System.getImage('cart/scroll_shadow.png', 'youpin'),
    SelectedProductBg: System.getImage('cart/selected_product_bg.png', 'youpin'),
    ServiceActDiffActiveLeft: System.getImage('cart/mishop_act_diff_active_left.png', 'mishop'),
    ServiceActDiffActiveRight: System.getImage('cart/mishop_act_diff_active_right.png', 'mishop'),
    ServiceActDiffUnactiveLeft: System.getImage('cart/mishop_act_diff_unactive_left.png', 'mishop'),
    ServiceActDiffUnactiveRight: System.getImage('cart/mishop_act_diff_unactive_right.png', 'mishop'),
    QuestionTipGray: System.getImage('cart/question_tip_gray.png', 'mishop'),
    FromSkyCloseIcon: System.getImage('cart/from_sky_close_icon.png', 'mishop'),
    FromSkyMultipleImg: System.getImage('cart/from_sky_multiple_img.png', 'mishop'),
    FromSkyCartListCouponIcon: System.getImage('cart/from_sky_cart_list_coupon_icon.png', 'mishop'),
  },
  Address: {
    DefaultIcon: System.getImage('address/default_icon.png', 'mishop'),
  },
  Invoice: {
    InvoiceDownLoadIcon: System.getImage('address/default_icon.png', 'mishop'),
    OrderInvoiceSubSuccessIcon: System.getImage('invoice/edit_invoice_sub_suncess.png', 'mishop'),
    OrderInvoiceEditEmailDelectIcon: System.getImage('invoice/edit_email_delete_icon.png', 'mishop'),
    OrderInvoicePendingConfirmIcon: System.getImage('invoice/pending_confirm_icon.png', 'mishop'),
  },
  Coupon: {
    UpCouponShadow: System.getImage('coupon/up_coupon_shadow.jpg', 'youpin'), // UP会员优惠券底纹图
    UpCouponInvalidShadow: System.getImage('coupon/up_coupon_invalid_shadow.jpg', 'youpin'), // UP会员优惠券底纹图
    CouponHeaderRight: System.getImage('coupon/coupon_header_right.png', 'youpin'), // 专享优惠券header的右侧icon
    CouponHeaderLeft: System.getImage('coupon/coupon_header_left.png', 'youpin'), // 专享优惠券header的左侧icon
    BestCoupon: System.getImage('coupon/best_coupon.png', 'youpin'), // 弹窗- 最优可享
    NearExpirationRight: System.getImage('coupon/coupon_near_expriation_bg.png', 'youpin'), // 优惠券快过期角标，米网暂时没有图，用有品的替代
  },
  ProdDetail: {
    SkuSeckillIcon: System.getImage('product/sku_seckill_icon.png', 'youpin'),
  },
  Ecard: {
    CardBackground: System.getImage('ecard/card_background.png', 'mishop'),
    CashBackground: System.getImage('ecard/cash_background.png', 'mishop'),
    UsedBackground: System.getImage('ecard/used_background.png', 'mishop'),
    AddIcon: System.getImage('ecard/add_icon.png', 'mishop'),
    AnswerIcon: System.getImage('ecard/answer_icon.png', 'mishop'),
    QuestionIcon: System.getImage('ecard/question_icon.png', 'mishop'),
    HelpIcon: System.getImage('ecard/help_icon.png', 'mishop'),
    BackArrow: System.getImage('ecard/back_arrow.png', 'mishop'),
  },
  Checkout: {
    AddressDefault: System.getImage('checkout/address_default.png', 'mishop'), // 地址默认图标

    DashedLineBrown: System.getImage('checkout/checkoout_coupon_dashline.png', 'mishop'),
    DashedLineGray: System.getImage('checkout/dashed_line_gray.png', 'mishop'),
    CheckoutBoxUnselect: System.getImage('checkout/checkout_coupon_unselect.png', 'mishop'),
    CheckBoxCheckSelected: System.getImage('checkout/checkout_coupon_select.png', 'mishop'),
    CheckBoxChecklightOrigin: System.getImage('checkout/checkbox_coupon_disable.png', 'mishop'), // 消费券不可用的选框，淡淡的颜色

    CouponArrowUp: System.getImage('checkout/bg_arrow_up.png', 'mishop'), // 箭头-向上-浅黄色
    CouponArrowDown: System.getImage('checkout/bg_arrow_down.png', 'mishop'),
    CouponArrowUpGray: System.getImage('checkout/bg_arrow_up_gray.png', 'mishop'),
    CouponArrowDownGray: System.getImage('checkout/bg_arrow_down_gray.png', 'mishop'),
    ArrowRightOrigin: System.getImage('checkout/right_arrow_origin.png', 'mishop'), // 右箭头，橘色
    IMEIErrorTips: System.getImage('checkout/checkout_imei_error_tips.png', 'mishop'), // 输入IMEI时校验不通过icon
    OverLay: System.getImage('checkout/checkout_coupon_overlay.png', 'mishop'), // 结算页优惠券弹窗优惠券可叠加icon
    CalendarLeft: System.getImage('checkout/calendar_left.png', 'mishop'), // 结算页新日期左右翻页按钮
    CalendarRight: System.getImage('checkout/calendar_right.png', 'mishop'), // 结算页新日期左右翻页按钮

    questionGray: System.getImage('checkout/system-help.png', 'mishop'),
    whiteRightArrow: System.getImage('checkout/white_right.png', 'mishop'),
  },
  PaySuccess: {
    warnTip: System.getImage('paySuccess/warn_tip.png', 'mishop'),
    coupons_bg: System.getImage('paySuccess/coupons_bg.png', 'mishop'),
    silk: System.getImage('paySuccess/silk.png', 'mishop'),
    surprise_title: System.getImage('paySuccess/surprise_title.png', 'mishop'),
    icon_close: System.getImage('paySuccess/icon_close.png', 'mishop'),
    coupons_mask: System.getImage('paySuccess/coupons_mask.png', 'mishop'),
    FMemberBuyBG: System.getImage('paySuccess/f_member_buy_bg.jpeg', 'mishop'),
    ShareIcon: System.getImage('paySuccess/f_share_icon.png', 'mishop'),
    ShareIconNew: System.getImage('paySuccess/share_icon.png', 'mishop'),
    FMemberPaysuccessIcon: System.getImage('paySuccess/f_member_paysuccess_icon.png', 'mishop'),
    PaySuccessBg: System.getImage('paySuccess/pay_success_bg.png', 'mishop'),
    FMemberPaySuccessBg: System.getImage('paySuccess/f_member_pay_success_bg.png', 'mishop'),
    NormalGetCoinBg: System.getImage('paySuccess/get_coin_bg.png', 'mishop'),
    FMemberGetCoinBg: System.getImage('paySuccess/f_member_get_coin_bg.png', 'mishop'),
    NormalBuyBgContainer: System.getImage('paySuccess/buy_bg_container.png', 'mishop'),
    FMemberBuyBgContainer: System.getImage('paySuccess/f_member_buy_bg_container.png', 'mishop'),
    miCoinLogo: System.getImage('paySuccess/mi_coin_logo.png', 'mishop'),
    miMemberPaySuccessIcon: System.getImage('paySuccess/mi_member_pay_success_icon.png', 'mishop'),
    ConsumablesCardLogo: System.getImage('paySuccess/consumables_card_logo.png', 'mishop'),
  },
  Store: {
    Wechat: System.getImage('store/wechat.png', 'mishop'),
    MapIcon: System.getImage('store/map_icon.png', 'mishop'),
    TelIcon: System.getImage('store/tel_icon.png', 'mishop'),
    MapMoreIcon: System.getImage('store/map_more_icon.png', 'mishop'),
    ShareTransparent: System.getImage('store/share_transparent.png', 'mishop'),
    ShareWhite: System.getImage('store/share_white.png', 'mishop'),
    BackTransparent: System.getImage('store/back_transparent.png', 'mishop'),
    BackLight: System.getImage('store/back_light.png', 'mishop'),
    BackDark: System.getImage('store/back_dark.png', 'mishop'),
    BackWhite: System.getImage('store/back_white.png', 'mishop'),
    SearchIcon: System.getImage('store/search_icon.png', 'mishop'),
    DeleteIcon: System.getImage('store/delete_icon.png', 'mishop'),
    PriceDefault: System.getImage('store/price_default.png', 'mishop'),
    PriceAsc: System.getImage('store/price_asc.png', 'mishop'),
    PriceDesc: System.getImage('store/price_desc.png', 'mishop'),
    PlaceholderBox: System.getImage('store/placeholder_box.png', 'mishop'),
  },
};
ImageAssets.Auto = new Proxy(
  {
    Selected: {
      yp: System.getImage('common/selected_icon.png', 'youpin'),
      mi: System.getImage('common/selected.png', 'mishop'),
    },
    Unselect: {
      yp: System.getImage('common/unselected_icon.png', 'youpin'),
      mi: System.getImage('common/unselect.png', 'mishop'),
    },
    LocationIcon: {
      yp: System.getImage('location_icon_black.png', 'common'),
      mi: System.getImage('common/icon_location.png', 'mishop'), // 定位图标-灰色
    },
    LocationArrow: {
      yp: System.getImage('common/address_brown_arrow.png', 'youpin'), // 四级地址弹窗箭头
      mi: System.getImage('common/icon_location_arrow.png', 'mishop'),
    },
  },
  {
    get(t, p) {
      if (CommonBridge.isMishop()) {
        return t[p] && t[p].mi;
      } else {
        return t[p] && t[p].yp;
      }
    },
  },
);

const platformName = CommonBridge.isMishop() ? 'mishop' : 'youpin';
export { platformName };
export default ImageAssets;
